<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left">
    <div class="wrapper-login-page">
      <div class="login-page">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-login">
          <h1>{{'NEW_TEXT.create_your_account' | translate}}</h1>
          <h6>{{'NEW_TEXT.signup_for_a_new_account_by_adding_your_information_below' | translate}}</h6>
        </div>
        <form [formGroup]="createAccountForm" (ngSubmit)="onSubmitCreateAccountForm()" class="wrapper-content-auth">
          <div class="wrapper-input" [ngClass]="{'error': createAccountForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.' : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.email_address' | translate}}</span>
            <div class="custom-input">
              <input type="text" formControlName="email" placeholder="{{'NEW_TEXT.enter_you_email_address' | translate}}">
            </div>
            <div *ngIf="createAccountForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createAccountForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createAccountForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.phone_number' | translate}}</span>
            <div class="wrapper-phone-number open" [ngClass]="{'open': isAreaCodeOpen}">
              <div #areaCodeBtn class="wrapper-flags" (click)="isAreaCodeOpen = !isAreaCodeOpen">
                <img class="icon-flag" [src]="'../../../../assets/icons/flags/' + selectedArea.code.toLowerCase() + '.png'" alt="">
                <img class="icon-arrow-flags" src="../../../assets/icons/icon-arrow-left.svg" alt="">
              </div>
              <div class="wrapper-number-country">
                <span>{{selectedArea.phone_code}}</span>
              </div>
              <input type="text" formControlName="phone_number">
              <div class="content-dropdown-phone-number" *ngIf="isAreaCodeOpen">
                <div class="item-dropdown-phone-number" *ngFor="let country of Countries" (click)="onSelectCodeArea(country)">
                  <img [src]="'../../../../assets/icons/flags/' + country.code.toLowerCase() + '.png'" alt="">
                  <span>{{country.name}} ({{country.phone_code}})</span>
                </div>
              </div>
            </div>
            <div *ngIf="createAccountForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.' : formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createAccountForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createAccountForm.controls['password'] | formControlErrorMessages: null : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.password' | translate}}</span>
            <div class="custom-input">
              <input
                [type]="isPasswordVisible ? 'text' : 'password'"
                placeholder="{{'NEW_TEXT.enter_password' | translate}}"
                formControlName="password">
              <img *ngIf="!isPasswordVisible" (click)="isPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
              <img *ngIf="isPasswordVisible" (click)="isPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
            </div>
            <div *ngIf="createAccountForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createAccountForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
          </div><div class="wrapper-input" [ngClass]="{'error': createAccountForm.controls['confirmPassword'] | formControlErrorMessagesOnSubmit: 'Passwords do not match' : formTriedToSubmit}">
            <div class="custom-input">
              <input
                [type]="isConfirmPasswordVisible ? 'text' : 'password'"
                placeholder="{{'NEW_TEXT.enter_password' | translate}}"
                formControlName="confirmPassword">
              <img *ngIf="!isConfirmPasswordVisible" (click)="isConfirmPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
              <img *ngIf="isConfirmPasswordVisible" (click)="isConfirmPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
            </div>
          <div *ngIf="(createAccountForm.controls['confirmPassword'].errors && (formTriedToSubmit || createAccountForm.controls['confirmPassword'].touched))" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createAccountForm.controls['confirmPassword'] | formControlErrorMessagesOnSubmit: null: formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-custom-checkbox">
            <input formControlName="tos" type="checkbox" id="custom-checkbox">
            <label for="custom-checkbox">
              <span class="custom-checkbox-wrapper-check"></span>
              {{'NEW_TEXT.i_agree_to_the' | translate}} <span [routerLink]="[PAGES_AND_PATHS.termsAndConditions.pagePath]">{{'NEW_TEXT.terms_of_service' | translate}} </span>{{'NEW_TEXT.and' | translate}} <span [routerLink]="[PAGES_AND_PATHS.privacyPolicy.pagePath]">{{'NEW_TEXT.privacy_policy' | translate}}.</span>
            </label>
          </div>
          <button type="submit" [disabled]="createAccountForm.invalid" class="custom-btn custom-btn--primary">
            <span>{{'NEW_TEXT.create_account' | translate}}</span>
            <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
          </button>
          <span class="line-text">{{'NEW_TEXT.or_signup_with' | translate}}</span>
          <div class="wrapper-social-login">
            <div class="item-social-login" (click)="signInWithGoogle()">
              <img src="../assets/icons/icon-google.svg" alt="">
              <span>{{'NEW_TEXT.google' | translate}}</span>
            </div>
            <!--            <div class="item-social-login">-->
            <!--              <img src="../assets/icons/icon-facebook.svg" alt="">-->
            <!--              <span>Facebook</span>-->
            <!--            </div>-->
            <div class="item-social-login" (click)="signInWithApple()">
              <img src="../assets/icons/icon-apple.svg" alt="">
              <span>{{'NEW_TEXT.apple' | translate}}</span>
            </div>
          </div>
          <div class="wrapper-label-link">
            <span>{{'NEW_TEXT.already_have_an_account' | translate}}</span>
            <a href="javascript:void(0)" [routerLink]="[PAGES_AND_PATHS.login.pagePath]">{{'NEW_TEXT.login' | translate}}</a>
          </div>
        </form>
      </div>
      <div class="wrapper-sign-up-company-fixed">
        <div class="wrapper-btn-sign-up-company">
          <img src="../assets/icons/fill/icon-fill-company.svg" alt="">
          <span> {{'NEW_TEXT.for_companies' | translate}}</span>
          <a href="javascript:void(0)" [routerLink]="[PAGES_AND_PATHS.createCompanyAccount.pagePath]">{{'GENERAL.sign_up' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>
